<template>
  <div id="app">
    <van-nav-bar
      v-if="!$route.meta.hideHeader"
      left-text="返回"
      left-arrow
      class="header"
      @click-left="() => $router.go(-1)"
    />
    <router-view style="padding-bottom: 100px; box-sizing: border-box">
    </router-view>
    <tabbar v-show="$route.meta.isTabber"></tabbar>
  </div>
</template>

<script>
import tabbar from "./components/tabbar.vue";

export default {
  name: "app",

  components: { tabbar },

  created() {
  },

  methods: {

    
  },
};
</script>

<style lang="less" scoped>
.header {
  position: absolute;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
  /deep/ .van-nav-bar__text {
    color: #00706e;
  }
  /deep/ .van-icon-arrow-left:before {
    content: "\E668";
    color: #00706e;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue